export default ["$stateProvider", "$urlRouterProvider",function ($stateProvider, $urlRouterProvider) {
    // Now set up the states
    $stateProvider
        .state('invoiceList', {
            parent : "app",
            url: "/invoices?description&contractIdentifier&contract.formattedName&baCompany.name&amount.valueFrom&amount.valueUntil&fakDateFrom&fakDateUntil&id&download&downloadError&filterName&fakDateDynamicFilter&dueDateFrom&dueDateUntil", //&settled", // settled nicht nötig; wird hardcoded gesetzt!
            feature: "menu.invoices",
            views: {
                "main": {
                    template: require("./invoiceModule.html"),
                    controller: "InvoiceModuleController as $ctrl"
                }
            },
            resolve : {
                ctrl : ["$q","$ocLazyLoad", ($q,$ocLazyLoad)=> {
                    return $q((resolve)=>{
                        require.ensure([],()=>{
                            let module = require("./index.js");
                            $ocLazyLoad.load({name : module.default});
                            resolve();
                        });
                    });
                }]
            }
        });
      }];



// WEBPACK FOOTER //
// ./src/ui/modules/eaInvoice/routes.js